export default{
    computed:{
        title: function () {
            if (this.$route.path == '/checkout/basket'){
                return 'TERMÉKEK';
            }
            if (this.$route.path == '/checkout/data'){
                return 'RENDELÉS LEADÁSA';
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/main/components/pages/checkout/Checkout.js